module.exports = __webpack_public_path__ + "img/back_22.06346a28.svg";